import './starReader.css';
import StarIcon from './starIcon';

export default function StarReader({rating}) {

    const ratingMeater = rating;

    

    return(
        <div className="star-container">
            <StarIcon rating={ratingMeater < 1 ? true : false}/>
            <StarIcon rating={ratingMeater < 2 ? true : false}/>
            <StarIcon rating={ratingMeater < 3 ? true : false}/>
            <StarIcon rating={ratingMeater < 4 ? true : false}/>
            <StarIcon rating={ratingMeater < 5 ? true : false}/>
            <p>— {ratingMeater} stars!</p>
        </div>
    )
}